var _tspan, _tspan2, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVarReviewOver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    transform: "translate(9.45 36.4)",
    style: {
      fontSize: 8,
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.800000011920929px",
      fontFamily: "Rubik-SemiBold, Rubik",
      fontWeight: 600,
      letterSpacing: "0.0999755859375em"
    }
  }, "CH", /*#__PURE__*/React.createElement("tspan", {
    x: 13.04,
    y: 0,
    style: {
      letterSpacing: "0.093994140625em"
    }
  }, "E"), _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 18.83,
    y: 0
  }, "C")), /*#__PURE__*/React.createElement("tspan", {
    x: 25.18,
    y: 0,
    style: {
      letterSpacing: "0.093994140625em"
    }
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    style: {
      letterSpacing: "0.0789794921875em"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 3.24,
    y: 9.68
  }, "O")), /*#__PURE__*/React.createElement("tspan", {
    x: 9.5,
    y: 9.68,
    style: {
      letterSpacing: "0.0999755859375em"
    }
  }, "VER"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.44,11.73a.44.44,0,0,0-.13-.31.43.43,0,0,0-.33-.15H14.93a.54.54,0,0,0-.41.16.79.79,0,0,0-.17.25L13,15.82l-1.32-4.13a.61.61,0,0,0-.16-.26.57.57,0,0,0-.42-.16h-1a.46.46,0,0,0-.34.14.47.47,0,0,0-.12.32.62.62,0,0,0,0,.17l2.1,6.4a.69.69,0,0,0,.2.31.6.6,0,0,0,.42.15h1.31a.61.61,0,0,0,.43-.15.66.66,0,0,0,.2-.31l2.1-6.43A.78.78,0,0,0,16.44,11.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21,11.72a.67.67,0,0,0-.19-.31.64.64,0,0,0-.42-.14H19.07a.66.66,0,0,0-.42.14.61.61,0,0,0-.18.29l-2.39,6.45a.66.66,0,0,0,0,.15.47.47,0,0,0,.12.31.43.43,0,0,0,.33.15h1a.54.54,0,0,0,.4-.15.69.69,0,0,0,.15-.21l.36-1H21l.36.94a.65.65,0,0,0,.15.23.52.52,0,0,0,.4.15h1a.43.43,0,0,0,.33-.15.48.48,0,0,0,.13-.31.74.74,0,0,0,0-.18Zm-.58,3.93H19l.68-1.88Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.17,18.07,28.9,15.8a2.28,2.28,0,0,0,.79-.69,2.34,2.34,0,0,0,.4-1.37,2.23,2.23,0,0,0-.82-1.84,3.29,3.29,0,0,0-2.12-.63H24.5a.48.48,0,0,0-.35.14.47.47,0,0,0-.14.36v6.49a.48.48,0,0,0,.14.35.45.45,0,0,0,.35.15h1.09a.51.51,0,0,0,.36-.14.52.52,0,0,0,.14-.36V16.2h.81L28,18.35a1.49,1.49,0,0,0,.18.24.61.61,0,0,0,.45.17h1.11a.43.43,0,0,0,.33-.15.48.48,0,0,0,.13-.31A.43.43,0,0,0,30.17,18.07ZM28,13.73a.67.67,0,0,1-.19.52.91.91,0,0,1-.64.18h-1V13h1a.91.91,0,0,1,.64.18A.7.7,0,0,1,28,13.73Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 4,
    width: 28.66,
    height: 22.03,
    rx: 3,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "34.27 11.2 44.4 4.62 44.4 15.01",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "34.27 18.82 44.4 25.41 44.4 15.01",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVarReviewOver);
export default __webpack_public_path__ + "static/media/VAR_REVIEW_OVER.07eefdae4ae16a040ada0a3987790336.svg";
export { ForwardRef as ReactComponent };